import { LOCAL_STORAGE_KEYS } from './constants';
import Axios, { AxiosRequestConfig } from 'axios';
import { SessionUser } from 'features/Security/state/types';
// import store from '../../state/store'

export class TokenManager {
    public static getInstance = () => {
        if (!TokenManager.instance) {
            TokenManager.instance = new TokenManager();
        }
        return TokenManager.instance;
    }

    private static instance: TokenManager;
    private isRequestingToken = false;
    private queue: Array<(token: string) => Promise<string>> = []

    private constructor() {
    }

    public getCMSUser(): string | null {
        return localStorage.getItem(LOCAL_STORAGE_KEYS.CMS_USER);
    }

    public getToken(): string | null {
        return localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    }

    public getCSMUserData(): string | null {
        return localStorage.getItem(LOCAL_STORAGE_KEYS.LM_USER);
    }

    public storeToken(token: string): void {
        localStorage.setItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, token);
    }

    public storeCMSUser(refreshToken: string): void {
        localStorage.setItem(LOCAL_STORAGE_KEYS.CMS_USER, refreshToken);
    }

    public storeCMSUserData(user: string): void{
        localStorage.setItem(LOCAL_STORAGE_KEYS.LM_USER, user);
    }

    public clear(): void {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.CMS_USER);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.LM_USER);
        this.queue = [];
    }

    public getAuthentication(): AxiosRequestConfig {
        return {
            headers: { 'Authorization': 'Bearer ' + this.getToken() }
        };
    }

    public getNewToken(): Promise<string> {
        if (this.isRequestingToken) {
            // is already, put it in a queue ?
            return new Promise((resolve, reject) => {
                this.queue.push((token: string) => {
                    return new Promise((innerReslve, innerReject) => {
                        resolve(token)
                        innerReslve("")
                    })
                })
            })

        } else {
            this.isRequestingToken = true;
            const loggedObject = JSON.parse(this.getCMSUser() ?? "");
            const body = {
                "secret": loggedObject?.access_token ?? "",
                "metadata": JSON.stringify({ profile: loggedObject.profile })
            }
            return new Promise((resolve, reject) => {
                Axios
                    .post(`${process.env.REACT_APP_LISMA_API_BASE_URL}/security/session`, body)
                    .then(response => {
                        this.storeToken(response.data.token);
                        this.isRequestingToken = false;

                        while (this.queue.length > 0) {
                            const item = this.queue.shift()
                            if (item) {
                                item(response.data.token).then()
                            }
                        }
                        resolve(response.data.token);
                    })
                    .catch((error) => {
                        // store.dispatch({
                        //     type: LOGOUT_REQUEST
                        // })
                        // this.isRequestingToken = false;
                        // reject(error);
                    });
            });
        }
    }
}